<!--工作室详情首页-->
<template>
    <div class="studio_nav_content" v-loading="loading">
        <div class="left-container">
            <div class="studio-stats-container">
                <div class="title-box100">
                    <div class="title-name100 title-active">工作室信息</div>
                </div>
                <div class="studio-info">
                    <div class="studio-img">
                        <img class="studio-img-img" :src="groupInfo.groupAvatar" alt>
                    </div>
                    <div class="studio-name-care">
                        <div class="studio-name">{{ groupInfo.groupName }}</div>
                        <div class="studio-care-btn"  @click="getStudioCareOrCancel">
                            {{ groupInfo.isCare === 1 ? '取消关注' : '关注' }}
                        </div>
                        <div class="studio-care-num"><span>{{ groupInfo.careNum }}</span>人关注</div>
                    </div>
                </div>
                <div class="studio-stats">
                    <div class="status-item" @click="viewMember">
                        <div class="status-item-num text1">{{ groupInfo.memberNum }}</div>
                        <div class="status-item-name" >成员</div>
                    </div>
                    <div class="status-item" @click="changeActiveNum(3)">
                        <div class="status-item-num text2">{{ groupInfo.achieveNum }}</div>
                        <div class="status-item-name" >成果</div>
                    </div>
                    <div class="status-item" @click="changeActiveNum(6)">
                        <div class="status-item-num text3">{{ groupInfo.logNum }}</div>
                        <div class="status-item-name">日志</div>
                    </div>
                    <div class="status-item" @click="changeActiveNum(4)">
                        <div class="status-item-num text4">{{ groupInfo.articleNum }}</div>
                        <div class="status-item-name" >文章</div>
                    </div>
                    <div class="status-item" @click="changeActiveNum(5)">
                        <div class="status-item-num text5">{{ groupInfo.courseNum }}</div>
                        <div class="status-item-name">示范课</div>
                    </div>
                </div>
            </div>
            <div class="studio-recommend-container">
                <div class="title-box100">
                    <div class="title-name100 title-active">名师工作室推荐</div>
                </div>
                <div class="studio-care-list">
                    <div class="studio-care-rank" v-for="(item,index)  in studioList.slice(0,10)" :key="item">
                        <div :id="'num' + (index + 1)" class="group-active-index">{{index+1}}</div>
                        <div class="group-active-name" @click="viewStudioDetail(item)">{{item.groupName}}</div>
                        <div class="group-active-care">
                            <span style="color:red;">{{item.careNum}}</span>人关注
                        </div>
                    </div>
                    <data-empty v-if="studioList&&studioList.length===0" title="暂无数据"/>
                </div>
            </div>
        </div>
        <div class="right-container">
            <div class="right-content">
                <!--资讯-->
                <div class="right-item-container">
                    <div class="title-box">
                        <div class="title-name title-active">资讯</div>
                        <div class="title-more" v-if="briefList&&briefList.length>8">更多>></div>
                    </div>
                    <div class="brief-container" v-if="briefList&&briefList.length>0">
                        <div class="brief-carousel">
                            <el-carousel interval="4000">
                                <el-carousel-item @click="goDetail(item)" v-for="item in briefList.slice(0,8)" :key="item">
                                    <img class="brief-img" :src="item.cover" alt />
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div class="brief-list">
                            <div class="brief-item" v-for="item in briefList" :key="item">
                                <div class="brief-title">【工作简报】{{item.title}}</div>
                                <div class="brief-time">{{timestampToTime(item.createTime) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-100" v-if="briefList&&briefList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <!--成果展示-->
                <div class="right-item-container mt10" >
                    <div class="title-box">
                        <div class="title-name title-active">成果展示</div>
                        <div class="title-more" @click="changeActiveNum(3)" v-if="achieveList&&achieveList.length>4" >更多>></div>
                    </div>
                    <div class="achieve-list">
                        <div class="achieve-item" @click="viewInformation(item,3)"  v-for="item in achieveList.slice(0,4)" :key="item" >
                            <div class="achieve-cover">
                                <img class="img-100" :src="item.cover" alt />
                            </div>
                            <div class="achieve-type-title">
                                <div class="achieve-name">{{item.title}}</div>
                            </div>
                        </div>
                        <data-empty v-if="achieveList&&achieveList.length===0" title="暂无成果"/>
                    </div>
                </div>
                <!--教师文章-->
                <div class="right-item-container mt10">
                    <div class="title-box">
                        <div class="title-name title-active">教师文章</div>
                        <div class="title-more" @click="changeActiveNum(4)" v-if="articleList&&articleList.length>8">更多>></div>
                    </div>
                    <div class="article-list" v-if="articleList&&articleList.length>0">
                        <div class="article-item" @click="viewInformation(item,4)" v-for="item in articleList.slice(0,8)" :key="item">
                            <div class="article-title">{{ item.title }}</div>
                            <div class="article-user">{{ item.trueName }}</div>
                            <div class="article-time">{{ timestampToTime(item.createTime) }}</div>
                            <div class="article-view">
                                <img alt src="../../assets/icon/img/eye_new.png">
                                <p>{{item.readNum }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="div-100" v-if="articleList&&articleList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
                <!--高水平示范课-->
                <div class="right-item-container mt10" >
                    <div class="title-box">
                        <div class="title-name title-active">高水平示范课</div>
                        <div class="title-more" @click="changeActiveNum(5)" v-if="courseList&&courseList.length>4">更多>></div>
                    </div>
                    <div class="course-list-box">
                        <div class="course-item" v-for="item in courseList.slice(0,4)" :key="item">
                            <div class="course-one" @click="viewCourse(item,5)">
                                <div class="course-cover">
                                    <img class="img-100" :src="item.courseCover" alt />
                                </div>
                                <div class="course-name">{{item.courseName}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-100" v-if="courseList&&courseList.length===0">
                        <dataEmpty title="暂无课程" />
                    </div>
                </div>
                <!--区本课程-->
                <div class="right-item-container mt10">
                    <div class="title-box">
                        <div class="title-name title-active">区本课程</div>
                        <div class="title-more" @click="changeActiveNum(7)" v-if="qbCourseList&&qbCourseList.length>1">更多>></div>
                    </div>
                    <div class="course-list-box">
                        <div class="course-item" v-for="item in qbCourseList.slice(0,4)" :key="item" @click="viewCourse(item,7)">
                            <div class="course-one">
                                <div class="course-cover">
                                    <img class="img-100" :src="item.courseCover" alt />
                                </div>
                                <div class="course-name">{{item.courseName}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-100" v-if="qbCourseList&&qbCourseList.length===0">
                        <dataEmpty title="暂无课程" />
                    </div>
                </div>
                <!--校本课程-->
                <div class="right-item-container mt10">
                    <div class="title-box">
                        <div class="title-name title-active">校本课程</div>
                        <div class="title-more" @click="changeActiveNum(8)" v-if="xbCourseList&&xbCourseList.length>4">更多>></div>
                    </div>
                    <div class="course-list-box">
                        <div class="course-item" v-for="item in xbCourseList.slice(0,4)" :key="item" @click="viewCourse(item,8)">
                            <div class="course-one">
                                <div class="course-cover">
                                    <img class="img-100" :src="item.courseCover" alt />
                                </div>
                                <div class="course-name">{{item.courseName}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-100" v-if="xbCourseList&&xbCourseList.length===0">
                        <dataEmpty title="暂无课程" />
                    </div>
                </div>
                <!--工作日志-->
                <div class="right-item-container mt10">
                    <div class="title-box">
                        <div class="title-name title-active">工作日志</div>
                        <div class="title-more" @click="changeActiveNum(6)" v-if="logList&&logList.length>8">更多>></div>
                    </div>
                    <div class="article-list" v-if="logList&&logList.length>0">
                        <div class="article-item" @click="viewInformation(item,6)" v-for="item in logList.slice(0,8)" :key="item" >
                            <div class="article-title">{{ item.title }}</div>
                            <div class="article-user">{{ item.trueName }}</div>
                            <div class="article-time">{{ timestampToTime(item.createTime) }}</div>
                            <div class="article-view">
                                <img alt src="../../assets/icon/img/eye_new.png">
                                <p>{{item.readNum }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="div-100" v-if="logList&&logList.length===0">
                        <dataEmpty title="暂无数据" />
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :title="'工作室成员'" v-model="isMemberShow" width="60%">
            <el-row>
                <el-col :span="6" v-for="item in memberList">
                    <div style="display: flex;width: 100%;align-items: center;">
                        <el-avatar @error="showDefaultImage" class="mb15 mt15" :size="50" :src="item.memberAvatar" />
                        <div class="ml15" style="margin-left: 15px;">
                            <div v-if="item.memberRole == 0">
                                主持人
                            </div>
                            <div v-if="item.memberRole == 1">
                               管理员
                            </div>
                            <div v-if="item.memberRole == 2">
                                成员
                            </div>
                            <div>姓名：{{ item.memberName }}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>

import dataEmpty from "@/components/dataEmpty.vue";
import {infoStudio, listStudioActive, studioCareOrCancel} from "@/api/admin/studio";
import {timestampToTime} from "@/utils/date";

export default {
    name:'detailHome',
    components:{dataEmpty},
    props:{
        studioId:{
            type: String,
            default:null
        },
    },
    watch:{},
    mounted() { this.getInfoStudio();},
    created() {},
    data() {
        return {
            isMemberShow:false,
            loading:false,
            timestampToTime,
            groupId:'',
            groupInfo: {},
            briefList:[],//工作简报
            achieveList:[],//成果
            articleList:[],//教师文章
            courseList:[],//高水平示范课
            qbCourseList:[],//区本课程
            xbCourseList:[],//校本课程
            memberList:[],
            logList:[],//工作日志
            studioList:[],
            studioNature:''
        }
    },
    methods: {
        showDefaultImage(e){
            e.target.src = 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/hy_logo.png';
        },
        getInfoStudio() {
            this.informationStudio(this.studioId);
        },
        informationStudio(groupId){
            infoStudio({ groupId: groupId }).then(res => {
                if (res.data.code === 1) {
                    this.groupInfo = res.data.data;
                    this.memberList = this.groupInfo.memberList
                    this.briefList = this.groupInfo.briefList;
                    this.achieveList = this.groupInfo.achieveList;
                    this.articleList = this.groupInfo.articleList
                    this.courseList = this.groupInfo.courseList;
                    this.qbCourseList = this.groupInfo.qbCourseList;
                    this.xbCourseList = this.groupInfo.xbCourseList;
                    this.logList = this.groupInfo.logList;
                    listStudioActive({ groupNature: this.groupInfo.groupNature }).then(res => {
                        this.studioList = res.data.data;
                    })
                }
            })
        },
        changeActiveNum(i) {
            this.$emit('change-nav-active', i);
        },
        viewInformation(item,i){
            this.$emit('view-studio-info-active',item.infoId, i);
        },
        viewCourse(item,i){
            this.$emit('view-studio-info-active',item.courseId, i);
        },
        getStudioCareOrCancel() {
            studioCareOrCancel({ groupId: this.groupInfo.groupId }).then(res => {
                if (res.data.code === 1) {
                    if (this.groupInfo.isCare === 1) {
                        this.groupInfo.isCare = 0;
                        this.groupInfo.careNum--;
                    } else {
                        this.groupInfo.isCare = 1;
                        this.groupInfo.careNum++;
                    }
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        viewStudioDetail(s){
            this.loading = true;
            this.studioNature = s.groupNature;
            let path = 'teachStudioHome';
            if (this.studioNature==='3'){
                path = 'rectorStudioHome';
            }
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '2',studioId:s.groupId,studioNature:this.studioNature});
            this.$router.go(0);
        },
        viewMember(){
            this.isMemberShow = true;
        }
    }
}

</script>

<style scoped>
.div-100{
    width: 100%!important;
    height: auto;
}
/deep/ .el-scrollbar .el-scrollbar__wrap {
    border-top: none !important;
}
/*标题栏*/
.title-box100{
    display: flex;
    width: 100%;
    height: 100%;
    border-bottom: 2px solid #3b62f8;
}
.title-name100{
    width: 100%;
    height: 34px;
    line-height: 34px;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #3b62f8;
    //background-color: #cecece;
    cursor: pointer;
    text-indent: 10px;
}
.title-box{
    display: flex;
    width: 100%;
    height: 34px;
    border-bottom: 2px solid #3b62f8;
}
.title-name{
    width: auto;
    height: 34px;
    line-height: 36px;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    //color: #fff;
    //background-color: #cecece;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    color: #3b62f8;
}
.title-active{
    //color: #fff;
    //background: #3b62f8!important;
}
.title-more{
    color: #666!important;
    font-size: 16px;
    height: 34px;
    line-height: 34px;
    margin-left: auto;
    padding-right: 10px;
    cursor: pointer;
}
.title-more:hover{
    color: #3b62f8!important;
}
/*主要内容*/
.studio_nav_content{
    display: flex;
    width: 100%;
    height: auto;
}
.left-container{
    width: 25%;
    background-color: #fff;
}
.studio-stats-container{
    width: 100%;
    height: auto;
}
.studio-info{
    display: flex;
    width: 90%;
    height: 80px;
    margin: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #cecece;
}
.studio-img{
    width: 28%;
    height: 100%!important;

}
.studio-img-img{
    width: 96%;
    height: auto;
    max-height: 96%;
}
.studio-name-care{
    width: 72%;
    height: 100%!important;
    padding-left: 10px;
    box-sizing: border-box;
}
.studio-name{
    width: 100%;
    height: 28px;
    line-height: 28px;
    color: #3b62f8;
    font-size: 16px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.studio-care-btn{
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    width: auto;
    border-radius: 5px;
    margin: 2% 0;
    display: inline-block;
    padding: 0 10px;
    background: #f48d28;
    color: #fff;
    text-align: center;
    cursor: pointer;
}
.studio-care-num{
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #333333;
    font-size: 16px;
    span{
        color: #f48d28;
    }
}
.studio-stats{
    display: flex;
    width: 90%;
    height: 50px;
    margin: auto;
    border-bottom: 1px dashed #cecece;
    padding-bottom: 10px;
}
.status-item{
    width: 20%;
    height: 50px;
    cursor: pointer;
}
.status-item-num{
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
}
.text1{
    color: rgba(56,148,255);
}
.text2{
    color: rgba(226,149,17);
}
.text3{
    color: rgba(173,31,211);
}
.text4{
    color: rgba(202,213,7);
}
.text5{
    color: rgba(226,149,17);
}
.status-item-name{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    color: #666;
    font-size: 1.1vw;
}
/*关注度排行*/
.studio-recommend-container{
    width: 100%;
    height: auto;
    margin-top: 10px;
}
.studio-care-list{
    width: 90%;
    height: 100%;
    margin: auto;
}
.studio-care-rank{
    display: flex;
    border-bottom: 1px dashed #cecece;
    cursor: pointer;
    margin: auto;
}
.group-active-index{
    width: 36px;
    line-height: 36px;
    text-align: left;
    font-size: 16px;
    padding-left: 5px;
    box-sizing: border-box;
}
.group-active-name{
    line-height: 36px;
    font-size: 16px;
    width: calc(100% - 120px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333333;
}
.group-active-care{
    width: 80px;
    line-height: 36px;
    text-align: right;
    color: #cecece!important;
    font-size: 16px;
}
#num1, #num2, #num3, #num4, #num5, #num6, #num7, #num8, #num9, #num10 {
    background: none !important;
    font-size: 20px;
    font-weight: bold
}
#num1 {
    color: #ed574a;
}
#num2 {
    color: #f8b551;
}
#num3 {
    color: #32b16c;
}
#num4, #num5, #num6,#num7, #num8, #num9, #num10 {
    color: #86c8ff;
}
.right-container{
    width: 74%;
    margin-left: 1%;
}
.right-content{
    width: 100%;
    height: 100%;
}
.right-item-container{
    width: 100%;
    box-sizing: border-box;
    height: auto;
    background-color: #fff;
}
.studio-intro{
    width: 100%;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
    text-indent: 30px;
    font-size: 16px;
    line-height: 30px;
}
/*工作简报*/
.brief-container{
    display: flex;
    width: 100%;
    height: auto;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.brief-carousel{
    width: 45%;
    height: 100%;
}
/deep/ .el-carousel{
    width: 100%;
    height: 240px;
}
/deep/ .el-carousel .el-carousel-item{
    width: 100%;
    height: 100%;
}
/deep/ .el-carousel .el-carousel-item img{
    width: 100%;
    height: 100%;
}
/*指示器按钮*/
/deep/ .el-carousel__button {
    width: 8px;
    height: 8px;
    border: none;
    border-radius: 50%;
    background-color: grey;
}
.brief-img{
    width: 100%!important;
    height: 240px;
    cursor: pointer;
}
.brief-list{
    width: 55%;
    height: 100%;
    padding-left: 10px;
    box-sizing: border-box;
}
.brief-item{
    display: flex;
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    border-bottom: 1px dashed #cecece;
    cursor: pointer;
}
.brief-item:last-child{
    border: none;
}
.brief-title{
    height: 30px;
    width: calc(100% - 140px);
    line-height: 30px;
    font-size: 16px;
    color: #3b62f8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.brief-time{
    width: 140px;
    height: 30px;
    line-height: 30px;
    color: #666;
    text-align: right;
    font-size: 15px;
}
/*成果*/
.achieve-list{
    background-color: #FFFFFF;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    align-items: center;
}
.achieve-item{
    width: 25%!important;
    height: 180px;
    padding: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.achieve-cover{
    width: 100%;
    height: 140px;
    img{
        width: 100%;
        height: 100%;
    }
}
.achieve-type-title{
    display: flex;
    height: 30px;
    width: 100%;
}
.achieve-name{
    height: 30px;
    line-height: 30px;
    width: 100%;
    color: #3b62f8;
    font-size: 16px;
    text-align: left;
    //font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/*教师文章*/
.article-list{
    background-color: #FFFFFF;
    width: 100%;
    height: auto;
    align-items: center;
    margin-top: 10px;
}
.article-item{
    display: flex;
    width: 100%;
    height: 30px;
    padding-left: 10px;
    box-sizing: border-box;
    cursor: pointer;
    border-bottom: 1px dashed #cecece;
}
.article-item:last-child{
    border: none!important;
}
.article-title{
    height: 30px;
    line-height: 30px;
    width: calc(100% - 300px);
    font-size: 16px;
    color: #3b62f8;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.article-user{
    width: 80px;
    height: 30px;
    line-height: 30px;
    color: #666;
    font-size: 16px;
    text-align: center;
}
.article-time{
    width: 140px;
    height: 30px;
    line-height: 30px;
    color: #666;
    font-size: 16px;
    text-align: center;
}
.article-view{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 80px;
    height: 30px;
    color: #3b62f8;
    font-size: 16px;
    padding-right: 10px;
    box-sizing: border-box;
    img{
        width: 20px;
        height: 20px;
        margin-right: 3px;
    }
}
/*课程*/
.course-list-box{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding: 10px;
    align-items: center;
    box-sizing: border-box;
}
.course-item{
    width: 25%!important;
    height: 170px;
    padding-right: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.course-one{
    width: 100%;
    height: 140px;
    border: 1px solid #cecece;
    border-radius: 4px;
    box-sizing: border-box;
}
.course-cover{
    width: 100%;
    height: 100%;
    img{
        width: 100%;
        height: 100%;
    }
}
.course-name{
    height: 30px;
    font-size: 16px;
    color: #333333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 30px;
}
</style>